import React from "react";
import { Button, Modal } from "react-bootstrap";

// Define the props interface for CommonModal
type CommonModalProps = {
  handleClose: () => void;
  show?: boolean;
  heading?: string;
  content?: React.ReactNode;
  customClassName?: string;
  customClassNameForBody?: string;
  customClassNameForHeader?: string;
  footerButtonsActive?: boolean;
  modalSize?: string;
  confirmBtnText?: string;
  showHeadingLine?: boolean;
  customClassNameForFooter?: string;
  rightHeaderComponent?: any;
  customClassNameForTitle?: string;
  customClassnameForHr?: string;
  backdrop?: boolean;
};

const CommonModal: React.FC<CommonModalProps> = ({
  handleClose,
  show,
  heading,
  content,
  customClassName,
  customClassNameForBody,
  footerButtonsActive,
  modalSize,
  customClassNameForHeader,
  showHeadingLine,
  confirmBtnText,
  customClassNameForFooter,
  rightHeaderComponent,
  customClassNameForTitle,
  customClassnameForHr,
  backdrop= true,
}) => {
  return (
    <div className={`${customClassName}`}>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop={backdrop}
        centered
        className={`${modalSize} custom-modal vewScanLogPadding`}
      >
        <Modal.Header
          className={`${customClassNameForHeader} me-1`}
          closeButton
        ></Modal.Header>
        {heading && (
            <>
          <div className="d-flex justify-content-between modalHeading me-5">
            <Modal.Title className={`${customClassNameForTitle} h5 fw-bold ms-1`}>{heading}</Modal.Title>
            <span  className="mb-2">{rightHeaderComponent}</span>        
          </div>
          <hr className={`${customClassnameForHr}`}></hr>
          </>   
        )}

        {showHeadingLine }
        <Modal.Body className={`${customClassNameForBody}`}>
          {content}
        </Modal.Body>

        {footerButtonsActive && (
          <>
            <hr></hr>
            <Modal.Footer className={`${customClassNameForFooter}`}>
              <Button className="btn sph-shift sph-btn" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="sph-btn" onClick={handleClose}>
                {confirmBtnText ? confirmBtnText : "Save"}
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </div>
  );
};

export default CommonModal;
